import axios from "axios";
import { invalidateSession } from "./sessionsActions";

export const updateGuestRegisterData = (data) => {
  return {
    type: "GUEST_REGISTER_DATA",
    payload: data,
  };
};

export const updateGuestManageData = (data) => {
  return {
    type: "GUEST_MANAGE_DATA",
    payload: data,
  };
};

export const authGuest = (params) => async () => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/nocApi/auth/login-guest`,
      params,
      { withCredentials: true }
    );

    // Handle prefetch_blocked response (email client preview blocked)
    if (res.data?.prefetch_blocked) {
      console.log(
        "[authGuest] Prefetch blocked by server - this shouldn't happen for real users"
      );
      return {
        success: false,
        prefetchBlocked: true,
      };
    }

    // Handle existing_session response (stealth bot blocked - active session exists)
    if (res.data?.existing_session) {
      console.log(
        "[authGuest] Blocked: existing session detected, likely stealth bot"
      );
      return {
        success: false,
        existingSession: true,
      };
    }

    if (!res.data || res.data.success !== true) {
      return {
        success: false,
      };
    }

    if (res.data.success === true) {
      return {
        success: true,
        data: res.data,
      };
    } else {
      return {
        success: false,
      };
    }
  } catch (e) {
    // Handle 409 Conflict (another login attempt in progress) specially
    if (e.response?.status === 409) {
      return {
        success: false,
        conflict: true,
        alreadyLoggedIn: e.response?.data?.already_logged_in || false,
        message:
          e.response?.data?.message || "Another login attempt is in progress.",
      };
    }
    return {
      success: false,
    };
  }
};

export const fetchGuestData = (sessionName) => async (dispatch, getState) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/nocApi/signee/get-data`,
      { sessionName: sessionName },
      { withCredentials: true }
    );
    if (res.data.registerData === true) {
      dispatch(updateGuestRegisterData(res.data.data));
    } else {
      dispatch(updateGuestManageData(res.data.data));
    }

    return res.data;
  } catch (error) {
    const { sessions } = getState();
    dispatch(invalidateSession(sessions.currentSession));
    return;
  }
};

export const setInstantRonAccepted = () => {
  return { type: "SET_INSTANT_RON_ACCEPTED" };
};

export const setInstantRonInitialState = () => {
  return { type: "SET_INSTANT_RON_INITIAL_STATE" };
};

export const setDocumentAcceptedInitialState = () => {
  return { type: "SET_DOCUMENT_ACCEPTED_INITIAL_STATE" };
};

export const setDocumentAccepted = (data) => {
  return { type: "SET_DOCUMENT_ACCEPTED", payload: data };
};

export const setInstantRonStop = () => {
  return { type: "SET_INSTANT_RON_STOP" };
};

export const setInstantRonSuccess = () => {
  return { type: "SET_INSTANT_RON_SUCCESS" };
};

export const updateSignerRonDate = (data) => {
  return { type: "UPDATE_SIGNER_RON_DATE", payload: data };
};

export const setSignerRonInitial = () => {
  return { type: "SIGNER_RON_DATE_SET_INITIAL" };
};

export const completedNotaryRecordGuestSignal = (data) => {
  return { type: "COMPLETED_NOTARY_RECORD_GUEST_SIGNAL", payload: data };
};

export const getNotarizationStatus = (data) => {
  return { type: "NOTARIZATION_COMPLETED_STATUS_SIGNAL", payload: data };
};

export const setNotarizationStatusInitial = (data) => {
  return { type: "NOTARIZATION_COMPLETED_INITIAL" };
};
